import { useEffect, useState } from "react";
import { Globe, Send, ExternalLink } from "lucide-react";
import { Button } from "../ui/button";
import api from "../../lib/api";
import { toast } from "sonner";

const engineName = (ep) => ep.replace("https://", "").split("/")[0];

export default function SeoPanel() {
  const [st, setSt] = useState(null);
  const [bing, setBing] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => { api.get("/seo/indexnow/status").then(({ data }) => setSt(data)).catch(() => {}); api.get("/seo/bing-stats").then(({ data }) => setBing(data)).catch(() => {}); };
  useEffect(() => { load(); }, []);
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/seo/indexnow");
      const ok = data.results.filter((r) => r.ok).length;
      toast.success(`IndexNow inviato: ${ok}/${data.results.length} motori hanno accettato ${data.url_count} URL`);
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Invio IndexNow fallito");
    } finally { setBusy(false); }
  };
  const last = st?.last;
  return (
    <div className="bg-white rounded-2xl border border-stone-200 p-6" data-testid="seo-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-2">
        <h3 className="font-serif text-xl font-semibold text-[#0B2A45] flex items-center gap-2"><Globe className="w-5 h-5" />Indicizzazione Bing &amp; altri motori</h3>
        <Button onClick={submit} disabled={busy || !st?.ready} className="rounded-full bg-[#0F4C81] hover:bg-[#0B2A45]" data-testid="indexnow-submit-btn"><Send className="w-4 h-4 mr-2" />{busy ? "Invio..." : "Notifica motori (IndexNow)"}</Button>
      </div>
      <p className="text-sm text-stone-500 mb-4">IndexNow avvisa subito Bing (e quindi Yahoo, DuckDuckGo, Ecosia), Yandex e gli altri motori aderenti di tutte le {st?.url_count ?? "…"} pagine della sitemap. Usalo dopo ogni pubblicazione o modifica importante. Google non usa IndexNow: per Google resta la Search Console.</p>
      {st && !st.ready && <p className="text-sm text-red-600" data-testid="indexnow-not-ready">Chiave IndexNow non configurata sul server.</p>}
      {bing && (
        <p className="text-sm mb-3" data-testid="bing-stats">
          <span className="text-stone-500">Bing (API Webmaster): </span>
          {bing.configured === false ? <span className="text-stone-400">non configurata</span>
            : bing.error ? <span className="text-red-600">errore API</span>
            : bing.empty ? <span className="text-amber-700">nessun dato ancora — Bing non ha completato la prima scansione</span>
            : <span className="font-medium text-[#0B2A45]">{bing.in_index} pagine indicizzate · {bing.crawled} scansionate · {bing.errors} errori</span>}
        </p>
      )}
      {last ? (
        <div className="text-sm" data-testid="indexnow-last">
          <p className="text-stone-600 mb-2">Ultimo invio: <span className="font-medium text-[#0B2A45]">{last.at.slice(0, 16).replace("T", " ")}</span> · {last.url_count} URL</p>
          <ul className="flex flex-wrap gap-2">
            {last.results.map((r) => (
              <li key={r.engine} className={`px-3 py-1 rounded-full text-xs font-medium ${r.ok ? "bg-emerald-50 text-emerald-700" : "bg-red-50 text-red-700"}`} data-testid={`indexnow-result-${engineName(r.engine)}`}>{engineName(r.engine)} · {r.ok ? "OK" : `errore ${r.status ?? ""}`}</li>
            ))}
          </ul>
        </div>
      ) : <p className="text-sm text-stone-400" data-testid="indexnow-never">Nessun invio effettuato finora.</p>}
      <div className="mt-5 pt-4 border-t border-stone-100 flex flex-wrap gap-4 text-sm">
        <a href="/bing-webmaster.md" target="_blank" rel="noreferrer" className="text-[#0F4C81] hover:underline inline-flex items-center gap-1" data-testid="bing-guide-link"><ExternalLink className="w-3.5 h-3.5" />Guida Bing Webmaster Tools</a>
        <a href="https://www.bing.com/webmasters" target="_blank" rel="noreferrer" className="text-[#0F4C81] hover:underline inline-flex items-center gap-1"><ExternalLink className="w-3.5 h-3.5" />Apri Bing Webmaster</a>
        <a href="/google-business-gsc.md" target="_blank" rel="noreferrer" className="text-[#0F4C81] hover:underline inline-flex items-center gap-1"><ExternalLink className="w-3.5 h-3.5" />Guida Google Business / GSC</a>
      </div>
    </div>
  );
}
